import { IconAdornment } from '../icon/svg';
import React, { useEffect } from 'react';
import {
  useSlateStatic,
  ReactEditor,
} from 'slate-react';

import application from 'application';

import Helpers from '../../helpers';
import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';
import InlineChromiumBugfix from '../link/inline-chromium-bug-fix';

import ButtonOptionsForm from './button-options-form';

import {
  addStyleBlock,
  updateStyleBlock,
  deleteStyleBlock
} from './utilities';

import { ReactComponent as EditIcon } from 'assets/images/edit-icon.svg';

import './index.scss';

function Button(props) {

  const element = props.element;
  const attributes = props.attributes;
  const children = props.children;

  const editor = useSlateStatic();
  const elementPath = ReactEditor.findPath(editor, element);

  useEffect(function onLoad() {

    application.dynamicModulesManager.load('ace');

    addStyleBlock(element);

    return function onUnload() {
      deleteStyleBlock(element);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onElementChange() {

    return updateStyleBlock(element);

  }, [element]);

  async function showButtonOptions() {

    const result = await application.dialogsManager.displayWithHeader(ButtonOptionsForm, {
      title: 'Button options',
      contentConfiguration: {
        page: props.parentEntity,
        data: element
      }
    });

    if (result.cancelled === true) {
      return;
    }

    const value = result.value;

    Helpers.setAttributes(editor, {
      ...element,
      options: {
        ...value.options
      }
    }, elementPath);

    // Helpers.setChildren(editor, elementPath, [{ text: value.buttonText }], element.children.length);
  }

  function renderEditButton() {

    const buttonAttribtues = {
      type: 'button',
      className: 'button-options-edit-button',
      onClick: showButtonOptions
    };

    return <button {...buttonAttribtues}><EditIcon /></button>;

  }

  function renderButton() {

    const buttonOptions = element;

    const buttonBlockAttributes = {
      id: element.options?.id,
      className: 'ht-button button-block-container '
    };

    const linkButtonControlAttributes = {
      ...attributes,
      className: 'link-button-control',
      href: buttonOptions.url,
      target: '_blank'
    };

    return <div {...buttonBlockAttributes}>

      <a {...linkButtonControlAttributes}>
        <InlineChromiumBugfix />
        <IconAdornment element={element} position="start" />
        {children}
        <IconAdornment element={element} position="end" />
        <InlineChromiumBugfix />
      </a>
    </div>;

  }

  function renderMain() {

    const baseElementProperties = {
      ...props,
      customNodeControls: [
        nodeControls.HOVER_BACKGROUND_COLOR,
        nodeControls.HOVER_TEXT_COLOR,
        nodeControls.ICON_SETTINGS,
        nodeControls.ALIGNMENT
      ],
      className: 'button-container'
    };

    return <BaseElement {...baseElementProperties}>
      {renderButton()}
      {renderEditButton()}
    </BaseElement>;

  }

  return renderMain();

}

export default Button;